import React from 'react'
import styled, { keyframes } from 'styled-components'
import RightClick from './utils/rightClick'

const animationTime = '0.5s'
const scale = keyframes`
  0% {
    transform: scale(1.0);
  }

  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1.0);
  }
`

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
`

const TimeContainer = styled.div`
  cursor: pointer;
  transition: all ${animationTime};
  /* min-height: 16vh; */
`

const Button = styled.button`
  border: none;
  background: none;
  color: rgba(0, 0, 0, 0.45);
  transition: all ${animationTime};
  cursor: pointer;
`

const TimeStyle = styled.div`
  text-align: center;
  transition: all ${animationTime};
`

const ScoreStyle = styled.div`
  font-size: 5vh;
  text-align: center;
  color: red;
  font-weight: 600;
  text-align: center;
  align-self: center;
  transition: transform ${animationTime};
`

const Osaekomi = ({ toggleTime, time, timeOn, reset }) => {
  const resetTime = event => {
    event.preventDefault()
    reset()
  }

  const showTime = timeOn || time > 0
  const showIppon = time === 20
  const showScore = time >= 10
  const score = showIppon ? 'IPPON' : 'WAZARI'

  const timeStyle = {
    fontSize: `${showTime ? '18vh' : '0'}`,
    color: `${timeOn ? 'black' : 'rgba(0, 0, 0, 0.45)'}`
  }

  const button = {
    fontSize: '5vh',
    width: '100%',
    padding: `${showTime ? '5px 0 0 0' : '40% 0 0 0'}`
  }

  const scoreStyle = {
    transform: `${showScore ? 'scale(1.0)' : 'scale(0)'}`,
    animation: `${showScore ? `${scale} 0.5s linear 0.4s infinite` : ''}`,
    margin: `0 ${!showIppon ? '12vh' : '14.1vh'}`
  }

  const timeContainer = {
    padding: `${showTime ? '0 0 0 0' : '0 0 7vh 0'}`
  }

  return (
    <Container>
      <ScoreStyle style={scoreStyle}>{score}</ScoreStyle>
      <RightClick onLongPress={event => resetTime(event)}>
        <TimeContainer
          onClick={() => toggleTime()}
          onContextMenu={event => resetTime(event)}
          style={timeContainer}
        >
          <Button style={button}>OSAEKOMI</Button>
          <TimeStyle style={timeStyle}>{time}</TimeStyle>
        </TimeContainer>
      </RightClick>
    </Container>
  )
}

export default Osaekomi



// WEBPACK FOOTER //
// ./src/osaekomi.jsx